import { createApp } from "vue";
import App from "./App.vue";
import "./plugins/AdobeTypekit.js";
import router from "./router/index.js";
import "vuetify/dist/vuetify.min.css";
import * as components from "vuetify/lib/components";
import * as directives from "vuetify/lib/directives";

import VueScrollTo from "vue-scrollto";

createApp(App).mount("#app");

// Vuetifyのインポート方法を変更
import { createVuetify } from "vuetify";

const app = createApp(App);

// Routerの設定
app.use(router);

//vscroll
app.use(VueScrollTo);

// Vuetifyの設定 カラーテーマの設定もここ
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#dcf7ff", //1a237e
          secondary: "#2f4247",
        },
      },
    },
    options: { customProperties: true },
  },
});

app.use(vuetify);
app.mount("#app");

// import { createApp } from "vue";
// import App from "./App.vue";
// import "./plugins/AdobeTypekit.js";
// import router from "./router/index.js";
// import "vuetify/dist/vuetify.min.css";
// import { createVuetify } from "vuetify";
// import * as components from "vuetify/lib/components";
// import * as directives from "vuetify/lib/directives";

// const app = createApp(App);

// // Routerの設定
// app.use(router);

// // Vuetifyの設定
// const vuetify = createVuetify({
//   components,
//   directives,
// });

// app.use(components);
// app.use(directives);
// app.use(vuetify);
// app.mount("#app");
